module.exports = __webpack_public_path__ + "img/success.5e7076a8.png";